import React from "react";
import { NavigateFunction } from "react-router";

interface Suborg {
  suborg: string;
  title: string;
  description: string;
}

interface SearchSuborgDialogProps {
  query: string | null;
  cards: Suborg[];
  orgSlug: string;
  navigate: NavigateFunction;
  setShowSearchDropdown: (value: string | null) => void;
  setSendInitMessage: (value: boolean) => void;
}

export const SearchSuborgDialog: React.FC<SearchSuborgDialogProps> = ({
  query,
  cards,
  orgSlug,
  navigate,
  setShowSearchDropdown,
  setSendInitMessage,
}) => {
  if (!query || query.length === 0) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto p-6">
        <h2 className="text-xl font-bold mb-4">Search in Another Document Set</h2>
        <div className="mb-4">
          <div className="divide-y divide-gray-200">
            {cards.map((suborg) => (
              <button
                key={suborg.suborg}
                className="w-full p-4 hover:bg-gray-50 transition duration-150 text-left rounded-lg"
                onClick={() => {
                  setShowSearchDropdown(null);
                  setSendInitMessage(false);
                  navigate(`/${orgSlug}/chat/${suborg.suborg}`, {
                    state: { message: query },
                  });
                }}
              >
                <p className="text-lg font-semibold text-gray-900">
                  {suborg.title}
                </p>
                <p className="text-sm text-gray-500 mt-1">
                  {suborg.description}
                </p>
              </button>
            ))}
          </div>
        </div>

        <div className="flex gap-2">
          <button
            onClick={() => setShowSearchDropdown(null)}
            className="flex-1 bg-gray-500 text-white py-2 px-4 rounded hover:bg-gray-600 transition duration-150"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};
